"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _core = require("@material-ui/core");

var _formik = require("formik");

var React = _interopRequireWildcard(require("react"));

var yup = _interopRequireWildcard(require("yup"));

var _react2 = require("@emotion/react");

var _ = require("../../..");

var css = _interopRequireWildcard(require("./LoginForm.styles"));

var _errorCopy = _interopRequireDefault(require("../errorCopy"));

var _ErrorBar = _interopRequireDefault(require("../errorBar/ErrorBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LoginForm = function LoginForm(_ref) {
  var loginFn = _ref.loginFn,
      resetPasswordFn = _ref.resetPasswordFn,
      customError = _ref.customError;
  var isMobile = (0, _core.useMediaQuery)("(max-width: ".concat(_.theme.breakpoints.values.sm, ")"));

  var _useState = (0, React.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, React.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = (0, React.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showPassword = _useState6[0],
      setShowPassword = _useState6[1];

  var formik = (0, _formik.useFormik)({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: yup.object({
      email: yup.string().required(_errorCopy["default"].emailRequired).email(_errorCopy["default"].emailValid).max(64, _errorCopy["default"].emailMax),
      password: yup.string().required(_errorCopy["default"].passwordRequired).min(6, _errorCopy["default"].passwordMin)
    }),
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!loading) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                setLoading(true);
                setError(undefined);
                _context.prev = 4;
                _context.next = 7;
                return loginFn(values.email, values.password);

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](4);
                setError(_context.t0);

              case 12:
                setLoading(false);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 9]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });

  var handleCloseErrorBar = function handleCloseErrorBar() {
    setError(undefined);
  };

  (0, React.useEffect)(function () {
    setError(customError);
  }, [customError]);
  var currentTheme = (0, _react2.useTheme)();

  var themedEyeIcon = function themedEyeIcon() {
    return currentTheme.name === 'legacy' ? (0, _jsxRuntime.jsx)(_.Icons.EyeOpenHollow, {
      fill: formik.touched.password && formik.errors.password ? _.theme.colors.error : '#8D92B0',
      css: css.visibleIcon
    }) : (0, _jsxRuntime.jsx)(_.Icons.Eye, {
      fill: formik.touched.password && formik.errors.password ? _.theme.colors.error : '#959196',
      css: css.visibleIcon
    });
  };

  var themedEyeStrikeIcon = function themedEyeStrikeIcon() {
    return currentTheme.name === 'legacy' ? (0, _jsxRuntime.jsx)(_.Icons.EyeSlashHollow, {
      fill: formik.touched.password && formik.errors.password ? _.theme.colors.error : '#8D92B0',
      css: css.visibleIcon
    }) : (0, _jsxRuntime.jsx)(_.Icons.EyeStrike, {
      fill: formik.touched.password && formik.errors.password ? _.theme.colors.error : '#959196',
      css: css.visibleIcon
    });
  };

  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (0, _jsxRuntime.jsxs)("form", {
      onSubmit: formik.handleSubmit,
      children: [(0, _jsxRuntime.jsx)("div", {
        children: (0, _jsxRuntime.jsx)(_.TextFields.Outlined, {
          name: "email",
          label: "Email address",
          fullWidth: true,
          onChange: formik.handleChange,
          value: formik.values.email,
          onBlur: formik.handleBlur,
          error: formik.touched.email && Boolean(formik.errors.email),
          helperText: formik.touched.email && Boolean(formik.errors.email) ? formik.errors.email : ''
        })
      }), (0, _jsxRuntime.jsxs)("div", {
        css: css.passwordWrapper,
        children: [(0, _jsxRuntime.jsx)(_.TextFields.Outlined, {
          name: "password",
          label: "Password",
          type: showPassword ? 'text' : 'password',
          endIcon: "",
          fullWidth: true,
          value: formik.values.password,
          onChange: formik.handleChange,
          error: formik.touched.password && Boolean(formik.errors.password),
          helperText: formik.touched.password && Boolean(formik.errors.password) ? formik.errors.password : ''
        }), (0, _jsxRuntime.jsx)("button", {
          onClick: function onClick() {
            setShowPassword(!showPassword);
          },
          type: "button",
          css: css.showPassword,
          "aria-controls": "password",
          "aria-expanded": "false",
          "aria-label": "show password",
          children: showPassword ? themedEyeIcon() : themedEyeStrikeIcon()
        })]
      }), error && (0, _jsxRuntime.jsx)(_ErrorBar["default"], {
        error: error,
        closeFn: handleCloseErrorBar
      }), (0, _jsxRuntime.jsxs)("div", {
        css: _objectSpread(_objectSpread({}, css.actions), isMobile && css.mobile),
        children: [(0, _jsxRuntime.jsx)(_.Buttons.Primary, {
          type: "submit",
          loading: loading,
          fullWidth: isMobile,
          disabled: !(formik.isValid && formik.dirty),
          children: "Log in"
        }), (0, _jsxRuntime.jsx)("div", {
          children: (0, _jsxRuntime.jsx)("div", {
            css: css.forgotPassword,
            children: (0, _jsxRuntime.jsx)(_.Buttons.Text, {
              onClick: function onClick() {
                return resetPasswordFn();
              },
              children: "Forgot password?"
            })
          })
        })]
      })]
    })
  });
};

var _default = LoginForm;
exports["default"] = _default;